import React from 'react';

export const SubHeading = ({
  title = 'SubHeading',
  size = '12',
  color = '#828282',
  weight = 'normal',
}) => {
  return (
    <p
      style={{
        color: color,
        fontWeight: weight,
        fontSize: size,
        marginBottom: '1rem',
      }}
    >
      {title}
    </p>
  );
};
